"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    heading: {
      margin: theme.spacing(6, 0, 4),
      display: 'block'
    },
    wrapper: {
      '& > p': {
        margin: '0'
      },
      '& > p a[href*="mailto"]': {
        wordBreak: 'break-all'
      }
    }
  };
});
var Contact = function Contact(_ref) {
  var heading = _ref.heading,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    email = _ref.email,
    phone = _ref.phone,
    _ref$translations = _ref.translations,
    translations = _ref$translations === void 0 ? {
      email: 'Email',
      phone: 'Phone'
    } : _ref$translations;
  var classes = useStyles();
  if (!heading || !firstName || !lastName) return null;
  return __jsx("aside", {
    className: (0, _clsx.default)(classes.wrapper, 'aem-ms-cmp aem-ms-grid-view')
  }, __jsx(_core.Typography, {
    component: "strong",
    variant: "h3",
    dangerouslySetInnerHTML: {
      __html: heading
    },
    className: classes.heading
  }), __jsx("p", {
    className: classes.heading,
    dangerouslySetInnerHTML: {
      __html: "".concat(firstName, " ").concat(lastName)
    }
  }), email && __jsx("p", null, __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(translations.email, ": ")
    }
  }), __jsx("a", {
    href: "mailto:".concat(email),
    dangerouslySetInnerHTML: {
      __html: email
    }
  })), phone && __jsx("p", null, __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(translations.phone, ": ")
    }
  }), __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: phone
    }
  })));
};
var ContactEditConfig = {
  emptyLabel: 'Contact',
  isEmpty: function isEmpty(props) {
    return !(props.heading && props.firstName && props.lastName);
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/contact')(Contact, ContactEditConfig);
exports.default = _default;